<app-common-header-layout
  [headerCtaLabel]="'LOGIN.DONT_HAVE_ACCOUNT' | translate"
  [headerCtaRoute]="registerRoute"
  [trackingScreenName]="trackingScreenName"
  [trackingObject]="trackingObject$ | async"
  [showHeaderCta]="true"
>
  <app-heading
    [title]="'FORGOT_PASSWORD.TITLE' | translate"
    [subtitle]="'FORGOT_PASSWORD.SUBTITLE_MESSAGE' | translate"
    [hasLessMargin]="formBannerExist$ | async"
  >
  </app-heading>

  <div class="form-body">
    <app-form-banner
      *ngIf="error$ | async as errorMessage"
      [message]="errorMessage"
      bannerStyle="error"
    >
    </app-form-banner>

    <app-form-banner
      *ngIf="setPasswordMessage$ | async as successMessage"
      [message]="successMessage"
      bannerStyle="success"
    >
    </app-form-banner>

    <app-forgot-password-form
      [trackingObject]="trackingObject$ | async"
      [trackingAction]="forgotPasswordTrackingAction"
      (onForgotPasswordSubmit)="sendSetPasswordEmail($event)"
    >
    </app-forgot-password-form>

    <i2g-router-link
      class="back-to-login"
      e2eId="back-to-login"
      buttonStyle="default"
      [label]="'FORGOT_PASSWORD.BACK_BUTTON' | translate"
      [alignment]="alignmentEnum.center"
      [trackingObject]="trackingObject$ | async"
      [trackingAction]="loginTrackingAction"
      (click)="goToLogin()"
    >
    </i2g-router-link>
  </div>
</app-common-header-layout>

<i2g-full-screen-spinner [show]="processing$ | async"></i2g-full-screen-spinner>
